<div class="watermark">
    {{ text() }}
</div>
